
<template>
  <div>
    <button v-on:click="open" class="email-form-button">
      <span class="button-text">
        APPLY TODAY
      </span>
    </button>
    <email-form-modal
      v-show="modalIsOpen"
      v-on:close="close"
    />
  </div>
</template>

<script>
import EmailFormModal from './EmailFormModal.vue'

export default {
  name: 'email-flow',
  components: {
    'email-form-modal': EmailFormModal
  },
  data: function () {
    return {
      modalIsOpen: false
    }
  },
  methods: {
    close: function(){
      this.modalIsOpen = false
    },
    open: function(){
      this.modalIsOpen = true
    }
  }
};
</script>

<style scoped>

.email-form-button {
    font-size: 24px;
    background-color: #7E290C;
    color: white;
    border: 0px solid;
    border-color: white;
    padding: 20px 25px;
    display:block;
    margin: auto;
}
</style>
